import { render, staticRenderFns } from "./SystemNotificationCtrl.vue?vue&type=template&id=d2a0ad32&lang=pug&"
import script from "./SystemNotificationCtrl.vue?vue&type=script&lang=js&"
export * from "./SystemNotificationCtrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports